(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["demo"] = factory();
	else
		root["demo"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}({

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(41);
	
	__webpack_require__(40);
	
	/* global DatePickerModal */
	
	var content = __webpack_require__(53);
	
	function handleResult(err, dtm) {
	  if (err) {
	    return window.console.log('RESULT ERROR:', err);
	  }
	  if (!dtm) {
	    return window.console.log('RESULT: No Selection');
	  }
	  return window.console.log('RESULT:', dtm);
	}
	
	function openTest1() {
	  var value = new Date();
	
	  // September 15th of the previous year
	  var min = new Date(value.getFullYear() - 1, 8, 15);
	
	  // start of the year after next (end of coming year)
	  var max = new Date(value.getFullYear() + 2, 0, 1);
	
	  var options = {
	    monthsToShow: 3,
	    value: value,
	    min: min,
	    max: max,
	    checkDate: function (dtm) {
	      // console.log('checkDate', dtm);
	      if (dtm.getDay() === 5 && dtm.getDate() < 8) return false;
	      return true;
	    }
	  };
	
	  DatePickerModal.date(options, handleResult);
	}
	
	function init() {
	  document.body.innerHTML = content;
	  document.getElementById('test1').addEventListener('click', openTest1);
	}
	
	// start with init...
	document.addEventListener('DOMContentLoaded', init);

/***/ },

/***/ 40:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 41:
40,

/***/ 53:
/***/ function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12\">\n      <h1>md-datepicker demo</h1>\n\n      <p>\n        Interactive demonstration of the DatePickerModal control.\n      </p>\n\n      <button id=\"test1\" class='btn btn-primary'>Test 1</button>\n\n      <hr />\n      <br /><br />\n\n      <div id=\"#ipsum-text\" style=\"min-height:110%\">\n        <h3>Filler Text</h3>\n        <p>\n          The filler text below is to test the overflow/scrolling of the backdrop vs the overlay.\n        </p>\n        <p>\n          Lorem ipsum dolor sit amet, consectetur adipiscing elit. In condimentum velit sit amet neque sagittis molestie. Donec id\n          velit convallis, lacinia erat a, blandit massa. Vestibulum tincidunt leo non faucibus viverra. Class aptent taciti\n          sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Morbi pulvinar placerat aliquam. Donec\n          dignissim lorem et purus tempor rhoncus. Suspendisse hendrerit sed est quis feugiat. Aenean quis sapien augue.\n          Aenean vel neque a leo iaculis placerat imperdiet vitae tortor. Donec ultrices nunc porta, scelerisque augue eget,\n          malesuada sem. Maecenas et orci vitae orci luctus sagittis. Sed sodales, risus non efficitur eleifend, ex ante\n          faucibus diam, sit amet blandit nibh libero eget risus. Pellentesque tempus mi ut dui tincidunt dignissim. Nunc\n          sed neque nulla.\n        </p>\n        <p>\n          Vestibulum sollicitudin urna sed tristique gravida. Nunc varius libero vel eros hendrerit, ut congue leo ornare. Integer\n          placerat elit quam, quis varius enim tempus non. Phasellus sed quam nunc. Proin metus massa, pretium ornare metus\n          ut, luctus rhoncus leo. Cras condimentum sem ac orci aliquam, et rutrum sem consequat. Suspendisse convallis luctus\n          nulla, sit amet facilisis enim placerat eu. Maecenas iaculis in dolor et tempus. Aliquam venenatis blandit nulla\n          at vestibulum. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. In et nisl\n          malesuada, efficitur risus in, tristique tellus. Vestibulum lobortis malesuada odio et placerat. Duis lobortis\n          metus eget mi blandit vulputate. Cras a mattis orci. Curabitur ornare luctus nibh eu elementum. Nullam id erat\n          vel odio egestas semper.\n        </p>\n        <p>\n          Phasellus laoreet tortor urna. Nulla arcu neque, aliquet varius efficitur et, pulvinar molestie dolor. Nulla elementum neque\n          eget ipsum dignissim, eu sollicitudin turpis mollis. Duis et rhoncus felis. Sed blandit enim ac malesuada porttitor.\n          Donec posuere dapibus consectetur. Curabitur nisi turpis, egestas ut maximus a, fringilla ac neque. Aliquam erat\n          volutpat. Curabitur nec justo dignissim, placerat ante vitae, eleifend urna.\n        </p>\n        <p>\n          Vestibulum finibus sapien mauris, sed vehicula mi fermentum quis. Aenean blandit gravida laoreet. Duis tincidunt, ex ac auctor\n          condimentum, lectus libero faucibus ante, at consequat ex justo vitae est. Cras porttitor vestibulum placerat.\n          Duis eu arcu arcu. Quisque consequat arcu eget iaculis tincidunt. Ut nulla nisl, fringilla a mauris at, convallis\n          porta risus. Etiam vulputate porttitor sapien, et pharetra quam iaculis nec. Cras a tincidunt arcu. Mauris molestie\n          purus erat, sed tincidunt nisl dignissim in. Nam sed ultrices dolor, non elementum lorem.\n        </p>\n        <p>\n          Mauris ac volutpat neque. Sed dignissim, felis vitae porta fermentum, tortor neque porttitor neque, in euismod velit sem\n          ut sapien. Donec dapibus, nisl quis pulvinar dictum, est enim ornare eros, vitae accumsan turpis tortor a purus.\n          Donec lacus nibh, suscipit vel mollis at, molestie id libero. Phasellus vehicula ex in est congue, vitae interdum\n          elit scelerisque. Fusce leo tellus, volutpat et ex in, sodales mollis enim. Aenean sed finibus justo. Pellentesque\n          varius, metus ac mollis venenatis, ante leo faucibus ligula, aliquam consectetur erat dolor quis turpis. Praesent\n          a magna ac mauris tristique dictum eget ac eros.\n        </p>\n        <p>\n          Etiam auctor ante in nunc tempus euismod. Ut ornare interdum neque ut vestibulum. Quisque a magna ante. Aliquam efficitur\n          lacus sed pellentesque blandit. Cras semper cursus mauris, ut sodales tortor auctor sed. Aliquam eu mi ut metus\n          consequat rhoncus. Pellentesque ut odio suscipit, volutpat ipsum sit amet, lobortis nisi. Sed auctor neque vitae\n          lectus porta, non viverra ipsum rhoncus. Sed mollis ligula mi, sed mollis leo venenatis et. Donec ornare enim est,\n          et tincidunt lectus efficitur et. Nam ullamcorper sed eros a aliquam. Suspendisse vitae luctus lacus, et porta\n          tellus. Nullam commodo mollis dictum.\n        </p>\n        <p>\n          In tincidunt tellus vel quam tincidunt, eget molestie erat ultrices. Nulla facilisi. Nullam ex est, ultrices nec sagittis\n          sodales, bibendum et justo. Fusce sit amet neque at lectus gravida aliquam sit amet non dolor. Duis efficitur sapien\n          sed semper pretium. Proin eget sapien congue, tempor lacus vitae, pulvinar elit. Aliquam sit amet elit nec augue\n          finibus ultricies. Sed porta turpis condimentum leo ultrices, sit amet interdum erat faucibus. Etiam sit amet quam\n          lectus. Donec ac nisi ultrices, porttitor sem sit amet, pharetra dui.\n        </p>\n        <p>\n          Sed et tempus odio, at fermentum neque. Mauris placerat vitae dolor id mollis. Nunc facilisis, ante quis semper interdum,\n          turpis est elementum neque, eget lobortis arcu lorem nec sapien. Fusce imperdiet, mauris in malesuada scelerisque,\n          massa neque ornare urna, et commodo mi sapien id erat. Phasellus porta odio non nunc suscipit, et viverra mi mollis.\n          Mauris interdum, arcu eget condimentum efficitur, nisi ligula sollicitudin felis, eu sollicitudin odio arcu ut\n          dolor. Praesent condimentum fringilla luctus. Cras volutpat bibendum libero vehicula suscipit. Maecenas iaculis\n          libero ipsum, et cursus turpis volutpat sit amet. Curabitur sapien felis, iaculis a sem sit amet, tempor fermentum\n          lorem. Duis nisi est, bibendum vitae consequat quis, laoreet a diam. Ut faucibus lorem vitae leo tincidunt viverra.\n          Morbi semper massa felis, id scelerisque mi tincidunt sit amet. Phasellus non nibh a nisl scelerisque laoreet et\n          eu ipsum. Integer tristique diam ac convallis scelerisque. Aliquam hendrerit hendrerit enim, sed tincidunt arcu\n          varius pulvinar.\n        </p>\n        <p>\n          Curabitur sed pharetra velit. Praesent nibh enim, varius vitae nulla sed, pharetra lobortis ligula. Vestibulum ante nulla,\n          scelerisque id pellentesque ac, blandit eu purus. Fusce in massa elit. Aliquam sapien justo, luctus id est at,\n          dictum porta elit. Vivamus scelerisque nisi at rhoncus commodo. Vestibulum ante ipsum primis in faucibus orci luctus\n          et ultrices posuere cubilia Curae; Aliquam vestibulum elit sit amet metus porta, quis tempus enim condimentum.\n          Etiam placerat dolor odio, eu bibendum mauris consectetur eu. Class aptent taciti sociosqu ad litora torquent per\n          conubia nostra, per inceptos himenaeos.\n        </p>\n        <p>\n          Integer in libero hendrerit, commodo purus nec, vehicula ipsum. Aenean cursus elementum massa, sed volutpat justo semper\n          at. Proin sit amet neque sed tortor gravida sagittis. Proin tempus diam vel dolor fringilla tristique. In eget\n          luctus nunc. In quam nisl, rutrum quis ipsum eu, sagittis fermentum dui. Nunc sed lorem neque.\n        </p>\n      </div>\n    </div>\n  </div>\n</div>"

/***/ }

/******/ })))
});
;


/** WEBPACK FOOTER **
 ** demo.js
 **/